import React from "react";

import WorkShiftsList from "./WorkShiftsList";
import {
  AnimatedModal,
  ModalContent,
  ModalHeader,
} from "../../modals/AnimatedModal";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";

export default function WorkShiftListModal({ show, closeModal }) {
  return (
    <AnimatedModal
      isOpen={show}
      onClose={closeModal}
      width="60%"
      maxWidth="1000px"
    >
      <ModalHeader
        title="Turnos de Trabalho"
        icon={AccessAlarmIcon}
        onClose={closeModal}
      />
      <ModalContent>
        <WorkShiftsList />
      </ModalContent>
    </AnimatedModal>
  );
}
